<template>
  <div class="app-detail-page" v-if="info.id" v-loading="pageLoading">
    <div class="detail-header">
      <div class="detail-header__main">
        <h2>{{ info.app_name || info.app_code }}</h2>
        <p>{{ info.app_code }}</p>
      </div>
      <div class="detail-header__meta">
        <el-tag :type="Number(info.status) === 1 ? 'success' : 'info'">
          {{ Number(info.status) === 1 ? "启用" : "禁用" }}
        </el-tag>
        <el-tag effect="plain">版本：{{ configForm.version || "--" }}</el-tag>
      </div>
    </div>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="基础信息" name="base">
        <el-card shadow="never" class="detail-card">
          <el-form
            ref="baseFormRef"
            :model="baseForm"
            :rules="baseRules"
            label-width="110px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="应用名称" prop="app_name">
                  <el-input v-model.trim="baseForm.app_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应用编码">
                  <el-input v-model="baseForm.app_code" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="包名">
                  <el-input v-model.trim="baseForm.package_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态" prop="status">
                  <el-switch
                    v-if="$store.getters.isSuperAdmin"
                    v-model="baseForm.status"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="启用"
                    inactive-text="禁用"
                  />
                  <el-tag
                    v-else
                    :type="Number(baseForm.status) === 1 ? 'success' : 'info'"
                  >
                    {{ Number(baseForm.status) === 1 ? "启用" : "禁用" }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model.trim="baseForm.remark"
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="detail-actions">
            <el-button type="primary" :loading="baseSaving" @click="saveBase">
              保存基础信息
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="APP配置" name="config">
        <el-card shadow="never" class="detail-card">
          <el-form ref="configFormRef" :model="configForm" label-width="120px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="微信 Secret">
                  <el-input v-model.trim="configForm.wx_appSecret" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="微信 AppId">
                  <el-input v-model.trim="configForm.wx_appid" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="版本号">
                  <el-input v-model.trim="configForm.version" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="奖励比例">
                  <el-input v-model.trim="configForm.amount_number" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="APK 地址">
                  <el-input v-model.trim="configForm.apk_url" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="安全密钥">
                  <el-input v-model.trim="configForm.appSecurityKey" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="信息流ID">
                  <el-input v-model.trim="configForm.info_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="插屏ID">
                  <el-input v-model.trim="configForm.interstitial_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开屏ID">
                  <el-input v-model.trim="configForm.splash_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="激励ID">
                  <el-input v-model.trim="configForm.reward_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="激励名称">
                  <el-input v-model.trim="configForm.reward_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Banner ID">
                  <el-input v-model.trim="configForm.banner_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Taku Key">
                  <el-input v-model.trim="configForm.taku_key" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Taku AppId">
                  <el-input v-model.trim="configForm.taku_app_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="ECPM Client Key">
                  <el-input v-model.trim="configForm.ecpm_key" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="ECPM Server Key">
                  <el-input v-model.trim="configForm.ecpm_key2" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="马甲包广告">
                  <el-switch
                    v-model="configForm.open_vest_package_ad"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="配置 JSON">
                  <el-input
                    v-model.trim="configForm.app_config_json"
                    type="textarea"
                    :rows="5"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="detail-actions">
            <el-button type="primary" :loading="configSaving" @click="saveConfig">
              保存 APP 配置
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="Bootstrap策略" name="bootstrap-policy">
        <el-card shadow="never" class="detail-card">
          <div class="bootstrap-banner">
            当前策略来源：
            <el-tag size="mini" :type="bootstrapPolicySourceTagType">
              {{ bootstrapPolicySourceLabel }}
            </el-tag>
            <span class="bootstrap-banner__sub">
              {{ bootstrapPolicyTargetLabel }}
            </span>
          </div>

          <el-form
            ref="bootstrapPolicyFormRef"
            :model="bootstrapPolicyForm"
            label-width="140px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="SDK总开关">
                  <el-switch
                    v-model="bootstrapPolicyForm.sdk_enabled"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="网络日志调试">
                  <el-switch
                    v-model="bootstrapPolicyForm.network_log_debug"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="请求超时(ms)">
                  <el-input-number
                    v-model="bootstrapPolicyForm.request_timeout_ms"
                    :min="0"
                    :step="1000"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="加载超时(ms)">
                  <el-input-number
                    v-model="bootstrapPolicyForm.load_timeout_ms"
                    :min="0"
                    :step="1000"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="冷却时间(ms)">
                  <el-input-number
                    v-model="bootstrapPolicyForm.cool_down_ms"
                    :min="0"
                    :step="500"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="缓存时长(ms)">
                  <el-input-number
                    v-model="bootstrapPolicyForm.cache_ttl_ms"
                    :min="0"
                    :step="1000"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="版本标记">
                  <el-input v-model.trim="bootstrapPolicyForm.version_tag" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model.trim="bootstrapPolicyForm.remark"
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="effective-policy">
            <div class="effective-policy__title">实际生效值</div>
            <div class="effective-policy__grid">
              <div class="effective-policy__item">
                <span class="effective-policy__label">sdkEnabled</span>
                <span class="effective-policy__value">
                  {{ effectivePolicySummary.sdkEnabled }}
                </span>
              </div>
              <div class="effective-policy__item">
                <span class="effective-policy__label">requestTimeoutMs</span>
                <span class="effective-policy__value">
                  {{ effectivePolicySummary.requestTimeoutMs }}
                </span>
              </div>
              <div class="effective-policy__item">
                <span class="effective-policy__label">loadTimeoutMs</span>
                <span class="effective-policy__value">
                  {{ effectivePolicySummary.loadTimeoutMs }}
                </span>
              </div>
              <div class="effective-policy__item">
                <span class="effective-policy__label">coolDownMs</span>
                <span class="effective-policy__value">
                  {{ effectivePolicySummary.coolDownMs }}
                </span>
              </div>
              <div class="effective-policy__item">
                <span class="effective-policy__label">cacheTtlMs</span>
                <span class="effective-policy__value">
                  {{ effectivePolicySummary.cacheTtlMs }}
                </span>
              </div>
            </div>
          </div>

          <div class="detail-actions">
            <el-button
              type="primary"
              :loading="bootstrapPolicySaving"
              @click="saveBootstrapPolicy"
            >
              保存 Bootstrap 策略
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const createConfigForm = () => ({
  app_id: "",
  app_code: "",
  wx_appSecret: "",
  wx_appid: "",
  version: "",
  amount_number: "",
  apk_url: "",
  appSecurityKey: "",
  info_id: "",
  interstitial_id: "",
  splash_id: "",
  reward_id: "",
  reward_name: "",
  banner_id: "",
  taku_key: "",
  taku_app_id: "",
  ecpm_key: "",
  ecpm_key2: "",
  open_vest_package_ad: 0,
  app_config_json: "",
});

const createBootstrapPolicyForm = () => ({
  app_id: "",
  app_code: "",
  sdk_enabled: 1,
  request_timeout_ms: 15000,
  load_timeout_ms: 8000,
  cool_down_ms: 3000,
  cache_ttl_ms: 3600000,
  network_log_debug: 0,
  version_tag: "",
  remark: "",
});

export default {
  data() {
    return {
      activeTab: "base",
      pageLoading: false,
      baseSaving: false,
      configSaving: false,
      bootstrapPolicySaving: false,
      info: {},
      bootstrapPolicyMeta: {
        target_app_id: null,
        target_app_code: "",
        saved_policy: null,
        effective_policy: null,
      },
      baseForm: {
        id: "",
        app_name: "",
        app_code: "",
        package_name: "",
        status: 1,
        remark: "",
      },
      configForm: createConfigForm(),
      bootstrapPolicyForm: createBootstrapPolicyForm(),
      baseRules: {
        app_name: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  computed: {
    bootstrapPolicySourceLabel() {
      const source = this.bootstrapPolicyMeta.effective_policy
        ? this.bootstrapPolicyMeta.effective_policy.resolved_from
        : "default";
      if (source === "app") {
        return "APP级";
      }
      if (source === "global") {
        return "Global回退";
      }
      return "默认值";
    },
    bootstrapPolicySourceTagType() {
      const source = this.bootstrapPolicyMeta.effective_policy
        ? this.bootstrapPolicyMeta.effective_policy.resolved_from
        : "default";
      if (source === "app") {
        return "success";
      }
      if (source === "global") {
        return "warning";
      }
      return "info";
    },
    bootstrapPolicyTargetLabel() {
      const appCode =
        this.bootstrapPolicyMeta.target_app_code || this.baseForm.app_code || "--";
      return `目标：${appCode}`;
    },
    effectivePolicySummary() {
      const policy =
        (this.bootstrapPolicyMeta.effective_policy || {}).global_policy || {};
      return {
        sdkEnabled: policy.sdkEnabled === undefined ? "--" : String(policy.sdkEnabled),
        requestTimeoutMs:
          policy.requestTimeoutMs === undefined ? "--" : policy.requestTimeoutMs,
        loadTimeoutMs:
          policy.loadTimeoutMs === undefined ? "--" : policy.loadTimeoutMs,
        coolDownMs: policy.coolDownMs === undefined ? "--" : policy.coolDownMs,
        cacheTtlMs: policy.cacheTtlMs === undefined ? "--" : policy.cacheTtlMs,
      };
    },
  },
  methods: {
    fillForms(data = {}) {
      const config = data.app_config || {};
      this.info = data;
      this.baseForm = {
        id: data.id || "",
        app_name: data.app_name || "",
        app_code: data.app_code || "",
        package_name: data.package_name || "",
        status: Number(data.status ?? 1),
        remark: data.remark || "",
      };
      this.configForm = {
        app_id: data.id || "",
        app_code: data.app_code || "",
        wx_appSecret: config.wx_appSecret || "",
        wx_appid: config.wx_appid || "",
        version: config.version || "",
        amount_number: config.amount_number || "",
        apk_url: config.apk_url || "",
        appSecurityKey: config.appSecurityKey || "",
        info_id: config.info_id || "",
        interstitial_id: config.interstitial_id || "",
        splash_id: config.splash_id || "",
        reward_id: config.reward_id || "",
        reward_name: config.reward_name || "",
        banner_id: config.banner_id || "",
        taku_key: config.taku_key || "",
        taku_app_id: config.taku_app_id || "",
        ecpm_key: config.ecpm_key || "",
        ecpm_key2: config.ecpm_key2 || "",
        open_vest_package_ad: Number(config.open_vest_package_ad || 0),
        app_config_json: config.app_config_json || "",
      };
    },
    fillBootstrapPolicy(data = {}) {
      this.bootstrapPolicyMeta = {
        target_app_id: data.target_app_id || null,
        target_app_code: data.target_app_code || this.baseForm.app_code || "",
        saved_policy: data.saved_policy || null,
        effective_policy: data.effective_policy || null,
      };

      const sourcePolicy =
        data.saved_policy || data.effective_policy || createBootstrapPolicyForm();

      this.bootstrapPolicyForm = {
        app_id: this.baseForm.id || "",
        app_code: this.baseForm.app_code || "",
        sdk_enabled: Number(sourcePolicy.sdk_enabled ?? 1),
        request_timeout_ms: Number(sourcePolicy.request_timeout_ms ?? 15000),
        load_timeout_ms: Number(sourcePolicy.load_timeout_ms ?? 8000),
        cool_down_ms: Number(sourcePolicy.cool_down_ms ?? 3000),
        cache_ttl_ms: Number(sourcePolicy.cache_ttl_ms ?? 3600000),
        network_log_debug: Number(sourcePolicy.network_log_debug ?? 0),
        version_tag: sourcePolicy.version_tag || "",
        remark: sourcePolicy.remark || "",
      };
    },
    async getInfo() {
      const id = this.$route.query.id;
      if (!id) {
        return;
      }

      this.pageLoading = true;
      try {
        const appRes = await this.$api.getApp.getAppInfo({ id });
        this.fillForms(appRes.data || {});
        await this.getBootstrapPolicy();
      } finally {
        this.pageLoading = false;
      }
    },
    async getBootstrapPolicy() {
      const data = await this.$api.getApp.getBootstrapPolicyInfo({
        app_id: this.baseForm.id,
        app_code: this.baseForm.app_code,
      });
      if (data && data.code === 200) {
        this.fillBootstrapPolicy(data.data || {});
      }
    },
    async saveBase() {
      const valid = await new Promise((resolve) => {
        this.$refs.baseFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.baseSaving = true;
      try {
        const data = await this.$api.getApp.postSaveAppInfo({
          ...this.baseForm,
          status: Number(this.baseForm.status),
        });
        if (data.code === 200) {
          this.$message.success("基础信息保存成功");
          this.getInfo();
          this.$store.dispatch("getAppList");
        }
      } finally {
        this.baseSaving = false;
      }
    },
    async saveConfig() {
      this.configSaving = true;
      try {
        const data = await this.$api.getApp.postSaveAppConfig({
          ...this.configForm,
          app_id: this.baseForm.id,
          app_code: this.baseForm.app_code,
          open_vest_package_ad: Number(this.configForm.open_vest_package_ad),
        });
        if (data.code === 200) {
          this.$message.success("APP 配置保存成功");
          this.getInfo();
        }
      } finally {
        this.configSaving = false;
      }
    },
    async saveBootstrapPolicy() {
      this.bootstrapPolicySaving = true;
      try {
        const data = await this.$api.getApp.saveBootstrapPolicy({
          app_id: this.baseForm.id,
          app_code: this.baseForm.app_code,
          sdk_enabled: Number(this.bootstrapPolicyForm.sdk_enabled),
          request_timeout_ms: Number(this.bootstrapPolicyForm.request_timeout_ms),
          load_timeout_ms: Number(this.bootstrapPolicyForm.load_timeout_ms),
          cool_down_ms: Number(this.bootstrapPolicyForm.cool_down_ms),
          cache_ttl_ms: Number(this.bootstrapPolicyForm.cache_ttl_ms),
          network_log_debug: Number(this.bootstrapPolicyForm.network_log_debug),
          version_tag: this.bootstrapPolicyForm.version_tag,
          remark: this.bootstrapPolicyForm.remark,
        });
        if (data.code === 200) {
          this.$message.success("Bootstrap 策略保存成功");
          await this.getBootstrapPolicy();
        }
      } finally {
        this.bootstrapPolicySaving = false;
      }
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style lang="less" scoped>
.detail-header {
  margin-bottom: 18px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7fbff, #eef5ff);
  border: 1px solid #dde8f8;
}

.detail-header__main {
  h2 {
    margin: 0;
    color: #203864;
    font-size: 24px;
  }

  p {
    margin: 8px 0 0;
    color: #7a8da9;
  }
}

.detail-header__meta {
  display: flex;
  gap: 10px;
}

.detail-card {
  border-radius: 18px;
}

.detail-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.bootstrap-banner {
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f7fbff;
  border: 1px solid #deebfb;
  color: #35507a;
}

.bootstrap-banner__sub {
  margin-left: 10px;
  color: #7d8ead;
}

.effective-policy {
  margin-top: 18px;
  padding: 16px;
  border-radius: 14px;
  background: #fbfcff;
  border: 1px solid #e6eefb;
}

.effective-policy__title {
  margin-bottom: 12px;
  color: #23457e;
  font-weight: 600;
}

.effective-policy__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.effective-policy__item {
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #edf2fb;
}

.effective-policy__label {
  display: block;
  color: #7b8da9;
  font-size: 12px;
}

.effective-policy__value {
  margin-top: 6px;
  display: block;
  color: #1f3d6b;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .effective-policy__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .effective-policy__grid {
    grid-template-columns: 1fr;
  }
}
</style>
